import { values } from 'lodash'

export const DOCUMENT_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
}

export const DOCUMENT_STATUS_ARRAY = values(DOCUMENT_STATUS)
